import { cn } from "@/lib/utils"
import type { SiteCheckPoint } from "@/types/site"

const SLOTS = 90

export function UptimeStrip({ checks }: { checks: SiteCheckPoint[] }) {
  const padding = Math.max(0, SLOTS - checks.length)
  return (
    <div
      className="flex h-8 items-stretch gap-[2px]"
      role="img"
      aria-label={`Last ${checks.length} checks`}
    >
      {Array.from({ length: padding }).map((_, i) => (
        <span key={`pad-${i}`} className="bg-muted flex-1 rounded-[2px]" />
      ))}
      {checks.map((check) => (
        <span
          key={check.at}
          title={`${new Date(check.at).toLocaleString()} · ${
            check.ok
              ? `OK${check.ms ? ` in ${check.ms}ms` : ""}`
              : `Failed${check.code ? ` (HTTP ${check.code})` : ""}`
          }`}
          className={cn(
            "flex-1 rounded-[2px] transition-opacity hover:opacity-70",
            check.ok ? "bg-status-up" : "bg-status-down",
          )}
        />
      ))}
    </div>
  )
}
